import { DeleteOutlined } from "@ant-design/icons";
import { makeIconButton } from "../../icons/utils";

export const DeleteIconButton = makeIconButton(
  <DeleteOutlined style={{ color: "red" }} />,
  "Delete",
);
